import { StateStatus } from '@alycecom/utils';
import { pathOr, pipe } from 'ramda';

import { IRootState } from '../root.types';

import { IUsersState } from './users.reducer';

const pathToUsersState = (state: IRootState): IUsersState => state.users;

export const getIsFulfilled = pipe(pathToUsersState, state => state.status === StateStatus.Fulfilled);

export const getRecipientState = pipe(pathToUsersState, state => state.recipient);
export const getSenderState = pipe(pathToUsersState, state => state.sender);
export const getChiliPiperURL = pipe(pathToUsersState, pathOr(null, ['sender', 'chiliPiperUrl']));
